import { TableDataQa } from 'commons/types/enums'
import { Table } from 'ui/components'

import { useApplicationPipelineReportContext } from '../../context/ApplicationPipelineReportContext'
import { columns } from './columns'

export const ApplicationPipelineReportTable = () => {
  const {
    data: {
      form: { page, size },
      total,
      items
    },
    routeApi,
    isFetching
  } = useApplicationPipelineReportContext()
  const navigate = routeApi.useNavigate()

  return (
    <Table
      dataQa={TableDataQa.BP_REPORTS_APPLICATION_PIPELINE_REPORT}
      dataSource={items.map((item) => ({ item }))}
      loading={isFetching}
      columns={columns}
      pagination={{
        page,
        size,
        onChange: (page, size) => {
          navigate({ to: '.', search: (prev) => ({ ...prev, page, size }) })
        },
        total
      }}
    />
  )
}
